module.exports = "/_next/static/images/trafficDesign-04b266241467cb86075334f0c4b8bf4e.webp";